//angular imports
import { ChangeDetectionStrategy, Component, input } from "@angular/core";

//local imports
import { AbstractDepartmentModel } from "@app/catalog-common";


/**
 * @summary  Controls how department item is shown
 */
export enum DepartmentDisplayMode
{
    
    /**
     * @summary  Show name + code
     */
    FullName = 0,


        /**
     * @summary  The name only
     */
    Name = 0,

    /**
     * @summary  The code only
     */    
    Code = 1,
}

@Component({
  selector: "department-item",
  standalone: false,
  templateUrl: "./department-item.component.html",
  styleUrl: "./department-item.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentItemComponent {

  
  DisplayMode: typeof DepartmentDisplayMode = DepartmentDisplayMode;

  public department = input.required<AbstractDepartmentModel>();
  public displayMode = input<DepartmentDisplayMode>(DepartmentDisplayMode.FullName);
  
}
